<ngx-charts-bar-horizontal-stacked
  [view]="view"
  [scheme]="colorScheme"
  [results]="chartData"
  [gradient]="gradient"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [legend]="showLegend"
  [showXAxisLabel]="showXAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  (select)="onSelect($event)">
</ngx-charts-bar-horizontal-stacked>


// WEBPACK FOOTER //
// ./src/app/budget/components/summary-chart/summary-chart.component.html